// generated by genversion
export const version = '2.5.4';
//# sourceMappingURL=version.js.map